export default __webpack_public_path__ + "static/media/004-toolbox.4d80783f.png";